const _ = require('underscore');

const actions = require('../_actions.js');

const initialState = {
	is_loading: false,
	deployment_type: "",
	deployment_estimate: "",
	changes: "",
	validation_code: "",
	title: "",
	summary_of_changes: "",
	schedule_start: "",
	schedule_end: "",
	deploy_time: "",
	deploy_date: "",
	deploy_window: "",
	messages: []
};

module.exports = function plan(state, action) {
	if (typeof state === 'undefined') {
		return initialState;
	}

	switch (action.type) {
		case actions.NEW_DEPLOYMENT:
		case actions.START_DEPLOYMENT_GET:
		case actions.SET_REVISION:
		case actions.SUCCEED_REPO_UPDATE:
		case actions.TOGGLE_OPTION:
			return initialState;

		case actions.START_SUMMARY_GET:
			_.assign({}, state, initialState);
			return _.assign({}, state, {
				is_loading: true
			});

		case actions.SUCCEED_DEPLOYMENT_GET: {
			const deployment = action.data.data ? action.data.data.attributes : {};

			return _.assign({}, state, {
				is_loading: false,
				changes: deployment.changes,
				title: deployment.title || "",
				summary_of_changes: deployment.summary || "",
				validation_code: "success",
				deployment_type: deployment.deployment_type,
				deployment_estimate: deployment.deployment_estimate,
				schedule_start: deployment.schedule_start_unix || "",
				schedule_end: deployment.schedule_end_unix || ""
			});
		}

		case actions.SUCCEED_SUMMARY_GET: {
			let changes = {};
			// backend can sometimes return an empty array instead of an object
			if (action.summary.changes.length !== 0) {
				changes = action.summary.changes;
			}

			return _.assign({}, state, {
				deployment_type: action.summary.actionCode || "",
				deployment_estimate: action.summary.estimatedTime || "",
				is_loading: false,
				changes: changes,
				validation_code: action.summary.validationCode,
				messages: action.summary.messages
			});
		}
		case actions.FAIL_SUMMARY_GET: {
			const messages = _.assign([], state.messages);
			if (action.error.toString()) {
				messages.push({
					text: action.error.toString(),
					code: "error"
				});
			}

			return _.assign({}, state, {
				is_loading: false,
				validation_code: "error",
				changes: {},
				messages: messages
			});
		}

		case actions.SET_TITLE:
			return _.assign({}, state, {
				title: action.text
			});

		case actions.SET_SUMMARY:
			return _.assign({}, state, {
				summary_of_changes: action.text
			});

		case actions.SET_TIME:
			return _.assign({}, state, {
				deploy_time: action.deploy_time
			});

		case actions.SET_DATE:
			return _.assign({}, state, {
				deploy_date: action.deploy_date
			});

		case actions.SET_WINDOW:
			return _.assign({}, state, {
				deploy_window: action.deploy_window
			});

		default:
			return state;
	}
};
